import { useState } from 'react';
import { Box, Container, Stack, Tab, Tabs } from '@mui/material';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import DashboardIcon from '@mui/icons-material/Dashboard';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import ReceiptIcon from '@mui/icons-material/Receipt';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import BrudCrumbs from '../../components/BreadCrumbs';
import Page from '../../components/Page';
import PageTitle from '../../components/PageHeading';
import { pillTabsSx } from '../Global/Styling';

// Tab sub-pages
import AccountingDashboard from './Dashboard';
import ProfitLoss from './ProfitLoss';
import Ledger from './Ledger';
import GST from './GST';
import TDS from './TDS';
import Expense from './Expense';

// ----------------------------------------------------------------------
// Tab config — add/remove tabs here; order matters
const ACCOUNTING_TABS = [
  { label: 'Dashboard', value: 0, icon: <DashboardIcon />, component: <AccountingDashboard /> },
  { label: 'P & L', value: 1, icon: <TrendingUpIcon />, component: <ProfitLoss /> },
  { label: 'Ledger', value: 2, icon: <MenuBookIcon />, component: <Ledger /> },
  { label: 'GST', value: 3, icon: <ReceiptIcon />, component: <GST /> },
  { label: 'TDS', value: 4, icon: <RequestQuoteIcon />, component: <TDS /> },
  { label: 'Expense', value: 5, icon: <AccountBalanceWalletIcon />, component: <Expense /> }
];

// ----------------------------------------------------------------------
export default function Accounting() {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (_, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Page title="Kpros || Accounting">
      <Container maxWidth="xl">
        <Box pt={3} pb={3} mb={4}>
          {/* ── Page heading ── */}
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            className="pageHeading"
          >
            <Stack direction="row" alignItems="center" gap={1}>
              {/* <AccountBalanceIcon sx={{ color: '#4fbbc8', fontSize: '1.4rem' }} /> */}
              <PageTitle info="Accounting" />
            </Stack>
            <Box>
              <BrudCrumbs />
            </Box>
          </Stack>

          {/* ── Pill Tabs ── */}
          <Box mt={2} mb={1}>
            <Tabs
              value={activeTab}
              onChange={handleTabChange}
              aria-label="Accounting tabs"
              sx={pillTabsSx}
            >
              {ACCOUNTING_TABS.map((tab) => (
                <Tab
                  key={tab.value}
                  icon={tab.icon}
                  iconPosition="start"
                  label={tab.label}
                  value={tab.value}
                />
              ))}
            </Tabs>
          </Box>

          {/* ── Tab content ── */}
          <Box className="acct-tab-content">
            {ACCOUNTING_TABS.map((tab) => (
              <div
                key={tab.value}
                role="tabpanel"
                hidden={activeTab !== tab.value}
                id={`acct-tabpanel-${tab.value}`}
                aria-labelledby={`acct-tab-${tab.value}`}
              >
                {activeTab === tab.value && <Box pt={2}>{tab.component}</Box>}
              </div>
            ))}
          </Box>
        </Box>
      </Container>
    </Page>
  );
}
